/*
 * The words for a version of the ARC someone else saved
 * (arc-and-discovery-hardening, D28, B30, B33): who, and when, in the
 * viewer's own time zone. The banner and the conflict screen share them, so
 * the two never word the same news differently.
 */

/** "10:42", in the viewer's time zone. */
const TIME = new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** "12 Oct", in the viewer's time zone. */
const DAY = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' });

const sameDay = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

/**
 * "Pat Person saved a newer version of this ARC at 10:42." The date is added
 * when it was not today; "Someone" stands in for a name the backend did not
 * record, and the time is left out when it recorded none.
 */
export function newerVersionSentence(
  savedBy: string | null | undefined,
  savedAt: string | null | undefined,
  now: Date = new Date(),
): string {
  const who = savedBy?.trim() ? savedBy.trim() : 'Someone';
  if (!savedAt) return `${who} saved a newer version of this ARC.`;
  const when = new Date(savedAt);
  const time = TIME.format(when);
  return sameDay(when, now)
    ? `${who} saved a newer version of this ARC at ${time}.`
    : `${who} saved a newer version of this ARC on ${DAY.format(when)} at ${time}.`;
}
